import { Avatar, Button } from 'src/design-system'
import { CellContext } from '@tanstack/react-table'
import * as React from 'react'
import { CheckinTableRow } from '../data'
import { BulkCheckinSelectionContext } from '../../bulk-selection-context'

export const NameCell = (data: CellContext<CheckinTableRow, unknown>) => {
  const {
    id,
    positionName,
    isPreviousRole,
    authorName,
    authorAvatarUrl,
    slug,
  } = data.row.original
  const [fname, lname] = authorName.split(' ')
  const initials = fname[0] + (lname ? lname[0] : '')

  const [isHovered, setIsHovered] = React.useState(false)
  const { checkedCheckinIds, addCheckedCheckinId, removeCheckedCheckinId } =
    React.useContext(BulkCheckinSelectionContext)

  const isChecked = !!id && checkedCheckinIds.includes(id)

  const handleCheckboxChange = () => {
    if (!id) return
    if (isChecked) {
      removeCheckedCheckinId(id)
    } else {
      addCheckedCheckinId(id)
    }
  }

  const showCheckbox = id && (isHovered || isChecked)

  return (
    <div className="flex flex-row gap-x-3 items-center">
      <div
        className="relative flex-shrink-0"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {showCheckbox ? (
          <div className="h-8 w-8 flex items-center justify-center">
            <input
              type="checkbox"
              className="h-4 w-4"
              checked={isChecked}
              onChange={handleCheckboxChange}
            />
          </div>
        ) : (
          <Avatar
            size="sm"
            fallbackText={initials}
            src={authorAvatarUrl}
            alt={`Avatar for ${authorName}`}
          />
        )}
      </div>
      <div className="flex flex-col">
        <p className="font-bold m-0 w-max">{authorName}</p>
        {positionName && (
          <div className="flex items-center gap-1.5">
            <span className="text-gray-600 text-xs whitespace-nowrap truncate">
              {positionName}
            </span>
            {isPreviousRole && (
              <span
                className="text-xs leading-5 rounded whitespace-nowrap flex-shrink-0 px-1 py-px bg-[#E7E4E4] text-[#1B1818]"
              >
                Previous role
              </span>
            )}
          </div>
        )}
      </div>
      {slug && (
        <Button
          as="a"
          href={`/checkins/${slug}?ref=checkins`}
          variant="outline"
          size="sm"
          className="ml-auto opacity-0 group-hover/row:opacity-100 transition-opacity"
          data-turbo-frame="content"
          data-turbo-action="advance"
        >
          View Check-in →
        </Button>
      )}
    </div>
  )
}
